<template>
  <div class="survey-question-step">
    <v-switch
      v-if="!isPublic"
      :input-value="repeatable"
      color="brandPrimary"
      label="Allow survey to be retaken"
      hide-details
      @change="$emit('update:repeatable', $event)"
    />
    <Typography variant="h-5">Add questions and answers to your survey!</Typography>
    <QuizQuestionBuilder
      ref="builder"
      :questions="questions"
      :show-required-toggle="true"
      :show-correct-answers="false"
      @update:questions="$emit('update:questions', $event)"
      @deleted-questions="$emit('deleted-questions', $event)"
      @deleted-answers="$emit('deleted-answers', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import QuizQuestionBuilder from "@/components/module-builder/components/QuizQuestionBuilder/QuizQuestionBuilder.vue";

export default {
  name: "SurveyQuestionStep",
  components: {
    Typography,
    QuizQuestionBuilder,
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    repeatable: {
      type: Boolean,
      default: true,
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:repeatable", "update:questions", "deleted-questions", "deleted-answers"],
  methods: {
    validate() {
      return this.$refs.builder?.validate() ?? true;
    },
  },
};
</script>

<style scoped>
.survey-question-step {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
